import React from 'react';
import { color } from '@/theme/tokens';

const LINK_PATTERN = /(https?:\/\/[^\s<>"{}|\\^`[\]]+)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const URL_PATTERN = /^https?:\/\//;

const linkStyle: React.CSSProperties = {
    color: color.brand[50],
    textDecoration: 'underline',
    overflowWrap: 'anywhere',
};

/**
 * Renders text with clickable email and URL links.
 *
 * Automatically detects:
 * - Email addresses → renders as mailto: links
 * - URLs (http/https) → renders as external links with target="_blank"
 */
export const renderTextWithLinks = (text: string): React.ReactNode => {
    if (!text) return text;
    const parts = text.split(LINK_PATTERN);

    const filteredParts = parts.filter(part => part !== undefined);

    if (filteredParts.length === 1) {
        return text;
    }

    return filteredParts.map((part, index) => {
        if (EMAIL_PATTERN.test(part)) {
            return (
                // Static, non-reordered list built from derived data — index keys are stable here.
                // react-doctor-disable-next-line no-array-index-as-key
                <a key={index} href={`mailto:${part}`} style={linkStyle}>
                    {part}
                </a>
            );
        }

        if (URL_PATTERN.test(part)) {
            const cleanUrl = part.replace(/[.,;:!?)]+$/, '');
            const trailingPunctuation = part.slice(cleanUrl.length);

            return (
                // Static, non-reordered list built from derived data — index keys are stable here.
                // react-doctor-disable-next-line no-array-index-as-key
                <React.Fragment key={index}>
                    <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                        {cleanUrl}
                    </a>
                    {trailingPunctuation}
                </React.Fragment>
            );
        }

        return part;
    });
};
